import React from 'react'
import { Package, Users, Store, Activity } from 'lucide-react'

const PlatformOverview = ({appStats}) => {
  const platformStats = [
    {
      title: "Uploaded Deals",
      value: parseInt(appStats?.active_deals + appStats?.expired_deals).toLocaleString(),
      change: "+23",
      changeLabel: "this week"
    },
    {
      title: "Active Deals",
      value: appStats?.active_deals,
      change: "+5",
      changeLabel: "this week"
    },
    {
      title: "Total Subscribers",
      value: appStats?.total_subscribers,
      change: "+156",
      changeLabel: "this week"
    }
  ];

  
  const quickStats = [
    {
      title: "Pending Approvals",
      value: appStats?.pending_deals || 0,
      icon: <Package size={20} />
    },
    {
      title: "Active Vendors",
      value: appStats?.total_vendors || 0,
      icon: <Store size={20} />
    },
    {
      title: "Today's Signup",
      value: appStats?.today_subscribers || 0,
      icon: <Users size={20} />
    }
  ];

  return (
    <div className="flex flex-col gap-4 w-full p-4">
      {/* Platform Statistics Section */}
      <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-lg p-6">
        <div className="flex items-center gap-2 mb-6">
          <Activity size={20} className="text-white" />
          <h3 className="text-lg font-semibold text-white">Platform Overview</h3>
        </div>
        <div className="grid grid-cols-3 gap-6">
          {platformStats.map((stat, index) => (
            <div key={index} className="col-span-1">
              <div className="flex flex-col gap-2 items-center text-center">
                <h4 className="font-normal text-white text-sm opacity-90">{stat.title}</h4>
                <h3 className="text-2xl font-bold text-white">{stat.value}</h3>
                
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Stats Section */}
      <div className="mt-4">
        <h4 className="text-md font-semibold text-gray-700 mb-3">Quick Stats</h4>
        <div className="grid grid-cols-3 gap-4">
          {quickStats.map((item, index) => (
            <div key={index} className="col-span-1">
              <div className="flex flex-col gap-2 items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                <div className="text-green-500">
                  {item.icon}
                </div>
                <h4 className="font-normal text-center text-gray-600 text-sm">{item.title}</h4>
                <h3 className="text-lg font-semibold text-gray-800">{item.value}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PlatformOverview